import { PaymentStatus } from '@repo/common';
import { Button } from '@repo/shadcn';
import { Loader2Icon } from 'lucide-react';
import { useFormContext } from 'react-hook-form';

import { IwForm } from '@components/form';

import {
    AddPaymentFormSchema,
    INITIAL_VALUE,
    TAddPaymentForm,
} from '@/modules/cart/add-payment-form.schema.ts';
import { AddPayment } from '@/modules/cart/add-payment.component.tsx';

import { usePurchaseDetailsContext } from './purchase-details.context';

const AddPurchasePaymentComponent = () => {
    const { data, isPaymentLoading } = usePurchaseDetailsContext();
    const { watch } = useFormContext<TAddPaymentForm>();

    const payments = watch('payments');

    const formTotal =
        payments?.reduce(
            (total, payment) => total + (payment.amount ?? 0),
            0,
        ) ?? 0;

    const isPaid = data?.data?.payment?.status === PaymentStatus.PAID;
    const totalPrice = data?.data?.payment?.total_price ?? 0;
    const totalPaid = data?.data?.payment?.total_paid ?? 0;

    const dueAmount = totalPrice - totalPaid;

    const isButtonDisabled = isPaymentLoading || isPaid || formTotal === 0;

    console.log({
        isPaid,
        totalPrice,
        totalPaid,
        dueAmount,
        formTotal,
        isButtonDisabled,
    });

    if (isPaid) {
        return null;
    }

    return (
        <AddPayment totalPrice={dueAmount} multiplePayments={false}>
            <div className={'flex justify-end'}>
                <Button
                    disabled={isButtonDisabled}
                    className={'flex items-center justify-center'}
                >
                    {isPaymentLoading ? (
                        <>
                            <Loader2Icon />
                            Loading...
                        </>
                    ) : (
                        'Confirm Payment'
                    )}
                </Button>
            </div>
        </AddPayment>
    );
};

export const AddPurchasePayment = () => {
    const { handleAddPurchasePayment } = usePurchaseDetailsContext();
    return (
        <IwForm
            schema={AddPaymentFormSchema}
            initialValues={INITIAL_VALUE}
            onSubmit={(data) => {
                handleAddPurchasePayment(data as TAddPaymentForm);
            }}
        >
            <AddPurchasePaymentComponent />
        </IwForm>
    );
};

AddPurchasePayment.displayName = 'AddPurchasePayment';
